import * as actionType from '../actionTypes';

const initialState = {
    productTypeList: [],
    productList: []
}
const productConfigReducer = (state = initialState, action) => {
    // debugger;
    switch (action.type) {
        case actionType.PRODUCT_TYPE_LIST:
            return {
                ...state,
                productTypeList: action.productTypeList
            };
            case actionType.PRODUCT_LIST:
            return {
                ...state,
                productList: action.productList
            };
        default:
            return state
    }
}
export default productConfigReducer;
